exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2gcJx{float:right;position:relative;z-index:2;margin-right:15px;min-height:70px}._2gcJx ul{margin-bottom:10px}._2gcJx ul li{list-style:none;display:inline}.Ntl35{display:inline-block;text-decoration:none!important;font-size:11px;padding:25px 15px 10px;cursor:pointer;line-height:20px}._3hAr4{font-weight:700}.Ntl35,.Ntl35:active,.Ntl35:visited{color:#000;text-decoration:none}.Ntl35:hover{text-decoration:none;background-color:#eee;color:#f40000}._3vZVG{color:#000;font-size:.8em;margin:0 1px}._3vZVG:hover{color:#f40000}", ""]);

// exports
exports.locals = {
	"root": "_2gcJx",
	"link": "Ntl35",
	"active": "_3hAr4",
	"spacer": "_3vZVG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Navigation/Navigation.css
// module id = 1011
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13